import classNames from 'classnames';

import type { TabsElementProps } from './TabsElement.types';

export const TabsElement = ({ tabs, className }: TabsElementProps) => (
  <div
    role="tablist"
    className={classNames('flex flex-row p-2 gap-x-2 bg-gray-100 border border-gray-100 rounded-md', className)}
  >
    {tabs.map((tab) => (
      <button
        type="button"
        role="tab"
        aria-selected={tab.selected}
        key={tab.key}
        className={classNames(
          'text-xs text-gray-950 w-fit text-center h-full relative capitalize px-3 py-2 whitespace-nowrap rounded-md',
          tab.selected && 'bg-white shadow-sm',
        )}
        onClick={tab.onClick}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
